var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.03117 13.5C2.69451 13.5 2.40951 13.3833 2.17617 13.15C1.94284 12.9167 1.82617 12.6316 1.82617 12.2948V4.70517C1.82617 4.36839 1.94284 4.08333 2.17617 3.85C2.40951 3.61667 2.69451 3.5 3.03117 3.5H10.621C10.9577 3.5 11.2427 3.61667 11.476 3.85C11.7093 4.08333 11.826 4.36839 11.826 4.70517V7.7565L13.6568 5.92567C13.7552 5.82733 13.8656 5.80278 13.9882 5.852C14.1108 5.90111 14.1722 5.99489 14.1722 6.13333V10.8667C14.1722 11.0051 14.1108 11.0989 13.9882 11.148C13.8656 11.1972 13.7552 11.1727 13.6568 11.0743L11.826 9.2435V12.2948C11.826 12.6316 11.7093 12.9167 11.476 13.15C11.2427 13.3833 10.9577 13.5 10.621 13.5H3.03117ZM3.03117 12.5H10.621C10.6808 12.5 10.7299 12.4808 10.7683 12.4423C10.8069 12.4039 10.8262 12.3547 10.8262 12.2948V4.70517C10.8262 4.64528 10.8069 4.59611 10.7683 4.55767C10.7299 4.51922 10.6808 4.5 10.621 4.5H3.03117C2.97139 4.5 2.92228 4.51922 2.88384 4.55767C2.84539 4.59611 2.82617 4.64528 2.82617 4.70517V12.2948C2.82617 12.3547 2.84539 12.4039 2.88384 12.4423C2.92228 12.4808 2.97139 12.5 3.03117 12.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocam);
export default __webpack_public_path__ + "static/media/videocam.72e3a3c4037872c3a2122a7f53829c46.svg";
export { ForwardRef as ReactComponent };